import { ConfigApi, OrderApi } from './../../core/constants/api.constant';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { BaseService } from 'src/app/core/services/base.service';
import { AccountAccReqPayload, DelPOReqPayload, DelRPReqPayload, MobileConfiguration, PurchaseOrderReqPayload, ReferringPhysicianReqPayload } from './account-administration.d';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AccountAdministrationService extends BaseService {
    /*********************Properties*********************/
    /*********************Properties*********************/

    /*********************Constructor*********************/
    $showHeaderClockFlag = new Subject<any>();
    $updateMobileCnfgs = new Subject<any>();
  entityFormValue: any;
    constructor(protected http: HttpClient, private cache: CacheResolverService) {
      super(http);
    }
    /*********************Constructor*********************/

    /*********************Service Methods*********************/
    /*********************Service Methods*********************/

    /*********************Private Methods*********************/
    purchaseOrders(reqPayload: any) {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetPurchaseOrder);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
    }));

    }

    referringPhysician(reqPayload: any) {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetReferringPhysician);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    admin(reqPayload: any) {
      const url = super.serviceUrl(this.apiConfig.config,ConfigApi.GetAccountAdmin)
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
    }));
    }

    saveAccountAdministration(reqPayload: AccountAccReqPayload)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetAccountAdmin+ConfigApi.Save);

      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    savePurchaseOrder(reqPayload: PurchaseOrderReqPayload)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetPurchaseOrder+ConfigApi.Save);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    deletePurchaseOrder(reqPayload: DelPOReqPayload)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetPurchaseOrder);
      return super.delete(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    modifyReferringPhysician(reqPayload: ReferringPhysicianReqPayload)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.ReferringPhysician+ConfigApi.Modify);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    saveReferringPhysician(reqPayload: ReferringPhysicianReqPayload)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.ReferringPhysician+ConfigApi.Save);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    deleteReferringPhysician(reqPayload: DelRPReqPayload)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.ReferringPhysicianDelete);
      return super.delete(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    getMobileConfigurations(reqPayload: any)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetMobileData);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    addMobileConfiguration(reqPayload: any)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.Mobile);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    editMobileConfiguration(reqPayload: any)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.Modify+ConfigApi.Mobile);
      return super.put(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    deleteMobileConfiguration(mobileNum: number)
    {
      const url = super.serviceUrl(this.apiConfig.config, ConfigApi.Mobile+`/${mobileNum}`);
      return super.delete(url, {}).pipe(map((response: any) => {
        return response;
      }));
    }

    send340BPDFEmail(reqPayload: any)
    {
      const url = super.serviceUrl(this.apiConfig.order, OrderApi.sendEmail340BEntityFormPDF);
      return super.post(url, reqPayload).pipe(map((response: any) => {
        return response;
      }));
    }

    setFormValue(formData: any) {
      this.entityFormValue = formData;
    }
    getFormValue() {
      return this.entityFormValue;
    }
    /*********************Private Methods*********************/
}

